import React from 'react';

import Episode from '@/types/pages/api/podcasts/episode';

type Link = [string, React.FunctionComponent, string];

type EpisodeLinksProps = {
    episode: Episode;
    links: Link[];
};

const EpisodeLinks = (props: EpisodeLinksProps) => {
    const { links } = props;

    return (
        <ul className="flex gap-2 flex-wrap items-start justify-start">
            {links.map(([label, Icon, url]) => (
                <li key={label as string}>
                    {url && (
                        <a
                            href={url as string}
                            target="_blank"
                            className="group flex items-center space-x-2 items-center justify-start px-2 py-0.5 bg-white border border-t-[1px] border-slate"
                            aria-label={label as string}
                            rel="noreferrer"
                        >
                            <div className="w-5 h-5 rounded-lg bg-white">
                                <Icon />
                            </div>
                            <div className="inline-flex flex-col items-start justify-start pl-2">
                                <p className="text-xs font-buch text-gray-500">Listen on</p>
                                <p className="w-full text-xs font-halbfett leading-none text-gray-900">{label}</p>
                            </div>
                        </a>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default EpisodeLinks;
